// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.heroVideo_heroSection__UL1sh {
  position: relative;
  display: flex;
  flex-direction: column;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

.heroVideo_logoContainer__\\+sJYO {
  position: absolute;
  top: 20px;
  left: 16px;
  z-index: 10;
}

.heroVideo_logoImage__Q7TKu {
  height: auto;
  max-width: 120px;
  width: auto;
  object-fit: contain;
}

.heroVideo_audioIcon__fYtkj {
  position: absolute;
  top: 20px;
  right: 16px;
  z-index: 10;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.heroVideo_heroContent__nPkwG {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.heroVideo_heroVideoContainer__sGIj- {
  width: 100%;
  height: auto;
  aspect-ratio: 16 / 9;
  overflow: hidden;
  position: relative;
  cursor: pointer;
}

.heroVideo_videoElement__BDZ7q {
  width: 100%;
  height: 100%;
  object-fit: cover;
  
}

.heroVideo_videoPoster__P7bF3 {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.1);
}

.heroVideo_posterImage__ZJ1w7 {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 12px;
}

.heroVideo_playButton__2mCZJ {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 6;
  transition: opacity 0.3s ease;
}

.heroVideo_videoPoster__P7bF3:hover .heroVideo_playButton__2mCZJ {
  opacity: 0.8;
}

.heroVideo_stopButton__v8fHc {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 6;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  transition: opacity 0.3s ease;
}

.heroVideo_stopButton__v8fHc:hover {
  opacity: 0.8;
}

`, "",{"version":3,"sources":["webpack://./src/components/pwatv/HeroVideo/heroVideo.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,+EAA+E;AACjF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;;AAEnB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,eAAe;EACf,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;EACV,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd","sourcesContent":[".heroSection {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n}\n\n.logoContainer {\n  position: absolute;\n  top: 20px;\n  left: 16px;\n  z-index: 10;\n}\n\n.logoImage {\n  height: auto;\n  max-width: 120px;\n  width: auto;\n  object-fit: contain;\n}\n\n.audioIcon {\n  position: absolute;\n  top: 20px;\n  right: 16px;\n  z-index: 10;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.heroContent {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n\n.heroVideoContainer {\n  width: 100%;\n  height: auto;\n  aspect-ratio: 16 / 9;\n  overflow: hidden;\n  position: relative;\n  cursor: pointer;\n}\n\n.videoElement {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  \n}\n\n.videoPoster {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  cursor: pointer;\n  z-index: 5;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(0, 0, 0, 0.1);\n}\n\n.posterImage {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 12px;\n}\n\n.playButton {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 6;\n  transition: opacity 0.3s ease;\n}\n\n.videoPoster:hover .playButton {\n  opacity: 0.8;\n}\n\n.stopButton {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 6;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  transition: opacity 0.3s ease;\n}\n\n.stopButton:hover {\n  opacity: 0.8;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"heroSection": `heroVideo_heroSection__UL1sh`,
	"logoContainer": `heroVideo_logoContainer__+sJYO`,
	"logoImage": `heroVideo_logoImage__Q7TKu`,
	"audioIcon": `heroVideo_audioIcon__fYtkj`,
	"heroContent": `heroVideo_heroContent__nPkwG`,
	"heroVideoContainer": `heroVideo_heroVideoContainer__sGIj-`,
	"videoElement": `heroVideo_videoElement__BDZ7q`,
	"videoPoster": `heroVideo_videoPoster__P7bF3`,
	"posterImage": `heroVideo_posterImage__ZJ1w7`,
	"playButton": `heroVideo_playButton__2mCZJ`,
	"stopButton": `heroVideo_stopButton__v8fHc`
};
export default ___CSS_LOADER_EXPORT___;
